import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as S3 from 'aws-sdk/clients/s3';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  fileRequest;
  constructor() { }

  uploadFile(file: File, apiUrl: string): Observable<any> {
    return new Observable((observer) => {
      const formData = new FormData();
      formData.append('file', file); // Attach the file with the key expected by the backend
  
      const xhr = new XMLHttpRequest();
      xhr.open('POST', apiUrl, true);
  
      // Monitor progress
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          observer.next({ type: 0, value: event }); // Progress event
        }
      };
  
      xhr.onload = () => {
        if (xhr.status === 200) {
          observer.next({ type: 1, value: JSON.parse(xhr.response) }); // Successful response
          observer.complete();
        } else {
          observer.error({ type: 2, value: xhr.response }); // Error response
        }
      };
  
      xhr.onerror = () => {
        observer.error({ type: 2, value: 'File upload failed' });
      };
  
      xhr.send(formData);
    });
  }

  haversineDistance(lat1: number, lon1: number, lat2: number, lon2: number) {
    const toRadians = (degree: number) => (degree * Math.PI) / 180;
    const R = 6371; // Radius of the Earth in km
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
  }

  cancelUpload(): void {
    setTimeout(this.fileRequest.abort.bind(this.fileRequest), 1000);
  }
}
